// 90mod Update Notifier
// Shows a native-feeling in-app banner when a new version is deployed.
// Works in conjunction with version_poller.js but adds a visible notification
// instead of silently reloading, giving mobile users a tap-to-update experience.

(function () {
  'use strict';

  const BANNER_ID = 'mod-update-banner';
  let shownAt = null;

  function showUpdateBanner(newVersion) {
    // Don't show twice
    if (document.getElementById(BANNER_ID)) return;
    shownAt = Date.now();

    const banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.setAttribute('role', 'alert');
    banner.innerHTML = `
      <div class="mod-update-banner">
        <div class="mod-update-banner__inner">
          <div class="mod-update-banner__icon">
            <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </div>
          <div class="mod-update-banner__text">
            <strong>Update available</strong>
            <span>90mod ${newVersion || ''} is ready</span>
          </div>
          <button class="mod-update-banner__btn" id="mod-update-now">Update now</button>
          <button class="mod-update-banner__close" id="mod-update-dismiss" aria-label="Dismiss">×</button>
        </div>
      </div>
    `;

    document.body.appendChild(banner);
    requestAnimationFrame(() => banner.querySelector('.mod-update-banner').classList.add('mod-update-banner--visible'));

    document.getElementById('mod-update-now')?.addEventListener('click', () => {
      window.location.reload();
    });

    document.getElementById('mod-update-dismiss')?.addEventListener('click', () => {
      banner.querySelector('.mod-update-banner').classList.remove('mod-update-banner--visible');
      setTimeout(() => banner.remove(), 300);
    });

    // Auto-reload after 5 min if user hasn't dismissed
    setTimeout(() => {
      if (document.getElementById(BANNER_ID)) window.location.reload();
    }, 5 * 60 * 1000);
  }

  // Hook into version_poller — it fires a custom event when a new version is detected
  document.addEventListener('mod:version-update', (e) => {
    showUpdateBanner(e.detail?.version);
  });

  // Also check on visibility change (user returns to tab)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && shownAt && Date.now() - shownAt > 30_000) {
      // If banner was shown 30s+ ago and they're back, just reload
      window.location.reload();
    }
  });
})();
